import { useEffect } from "react";
import { createSocketConnection } from "../services/socketService/socketService";
import { getToken } from "../services/token-service/token.service";
import { getUserData } from "../services/user-service/user.service";
export const wsEvents = {
  AGENT_ONLINE: "AGENT_ONLINE",
  AGENT_OFFLINE: "AGENT_OFFLINE",
  CLAIMED: "CLAIMED",
  PUSHER_PING: "PUSHER_PING",
  PUSHER_PONG: "PUSHER_PONG",
  CONNECT_ONLY: "CONNECT_ONLY",
};
function listenChannel(callBack, channel, event) {
  window.Echo.private(channel).listen(event, (payload) => {
    callBack(payload);
  });

  return function cleanUp() {
    window.Echo.leaveChannel(`private-${channel}`);
  };
}
const token = getToken();
const userData = getUserData();
export const useSocket = ({ type, callBack }) => {
  useEffect(() => {
    createSocketConnection(token);
    switch (type) {
      case "AGENT_ONLINE": {
        return listenChannel(callBack, `users.${userData?.id}`, ".user.online");
      }
      case "AGENT_OFFLINE": {
        return listenChannel(
          callBack,
          `users.${userData?.id}`,
          ".user.offline"
        );
      }
      case "CLAIMED": {
        return listenChannel(
          callBack,
          `users.${userData?.id}`,
          ".conversation.claimed"
        );
      }
    }
  });
};
